import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Box , LinearProgress ,Card, Typography, } from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../Generales/ModalInformativo';
import moment from 'moment';
import {llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {        
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const BitacoraCambios = ({modalAbierto,setModalAbierto,titulo,balancin }) => {
  let history = useHistory();
  const classes = useStyles();
  const idusu= localStorage.getItem('UsuId');  
  const [espera,setEspera]= useState(false);
  const [mensaje, setMensaje] = useState('');
  const [aviso, setAviso] = useState(false);
  const[lista,setLista]= useState([])                                                                   
  const source = axios.CancelToken.source();      
  React.useEffect(()=>{    
   getListBitacora(balancin.Id)
    return ()=> {
      source.cancel();
    }     
      
  },[]);

   const getListBitacora=(idBit)=>{      
        
      const data = qs.stringify({    
        Usuario:idusu,  
        Balancin:idBit,        
        idDispositivo:'89y7gttvjhj98h'
      });
      const url = "/pilona/balancin/cambios";
      function respuestaListTabla(aux) {
        if (aux[0].Id !== -1) 
        {                                                                  
          setLista(aux)                
        }        
      }
  
      llamaApiCargaToken(data, url,respuestaListTabla, ErrorGeneral, setEspera, history, source);
    } 
    
    
  const cerrarBorrar = () => {        
    setAviso(false);
    setModalAbierto(false)
  };

    return ( 
    <Modal
      titulo={titulo} modalAbierto={modalAbierto}
      setModalAbierto={setModalAbierto} 
      tamanio={"sm"} cerrarBorrar={cerrarBorrar}
    >
    <form  noValidate autoComplete="off" fullWidth>       
      <Box  display="flex" flexDirection="column" className={classes.root} style={{overflowY:"true" }}>  
        { lista.length!==0?
          lista.map((registro)=>{
            const fecha = moment.utc(registro.Fecha);  
            const modificada= fecha.local(true).format("DD/MM/YYYY HH:mm");  
          return(   
          <Card style={{width:30+'rem',height:"2rem",alignContent:"center"}}>
            <Box display="flex" flexDirection={"row"} style={{marginLeft:".5rem" ,alignItems:"center"}}>
            {/*   <Typography component="p" variant="body2" style={{color:"#51ad32",fontWeight:"700"}}>
                {registro.Id}
              </Typography> */}
              <Typography component="p" variant="body2" style={{marginLeft:".5rem", marginRight:".5rem",fontSize:"12px" }} >
                {modificada}
              </Typography>
            <Typography id="outlinedTecnico"           
              component="p" variant="body2"  style={{color:"#51ad32",fontSize:"12px",fontWeight:"700" }}                                               
            >    
            { `  ${registro.Nota}`}
            </Typography>
            {/*   <Typography id="outlinedTecnico"           
              size="small"  style={{width:31+'rem'}}                                               
            >    
              {registro.Dir}
              </Typography> */}
            
            </Box>
          </Card>                               
          )
          })
          :<Card><Typography>Balancin Sin cambios</Typography></Card>}
      </Box>
    </form>
    </Modal>
    );
}
 
export default BitacoraCambios;